'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import '../../styles/aca.css';

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    firstName: '',
    email: '',
    phoneCode: '+1',
    phone: '',
    message: '',
  });

  function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
      const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
      const res = await fetch(`${supabaseUrl}/functions/v1/send-contact-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${supabaseAnonKey}`,
        },
        body: JSON.stringify({
          firstName: form.firstName,
          email: form.email,
          phone: `${form.phoneCode}${form.phone}`,
          message: form.message,
        }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || 'Failed to send message');
      }
      setSubmitted(true);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="contact-root">
      <div className="contact-main-bg"></div>
      <div className="contact-main-page">
        <div className="contact-logo-box">
          <div className="contact-logo-bg"></div>
        </div>
        <div className="contact-form-card">
          {submitted ? (
            <div className="contact-success">
              <div className="contact-success-title">Thank you!</div>
              <div className="contact-success-msg">Your message has been sent. We&apos;ll be in touch soon.</div>
              <Link className="contact-back-link" href="/p1">Back to Home</Link>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <h2 className="contact-form-title">Contact us</h2>
              {error && (
                <div style={{ color: 'red', marginBottom: '12px', fontSize: '14px' }}>{error}</div>
              )}
              <div className="contact-field-group">
                <label className="contact-label" htmlFor="firstName">First Name</label>
                <input
                  id="firstName"
                  type="text"
                  className="contact-input"
                  placeholder="Enter your name"
                  name="firstName"
                  value={form.firstName}
                  onChange={handleChange}
                />
              </div>
              <div className="contact-field-group">
                <label className="contact-label" htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  className="contact-input"
                  placeholder="Enter your best email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>
              <div className="contact-field-group">
                <label className="contact-label" htmlFor="phone">Phone</label>
                <div className="contact-phone-row">
                  <div className="contact-phone-code">
                    <select
                      className="contact-phone-select"
                      name="phoneCode"
                      value={form.phoneCode}
                      onChange={handleChange}
                    >
                      <option value="+1">+1</option>
                      <option value="+44">+44</option>
                      <option value="+61">+61</option>
                      <option value="+91">+91</option>
                    </select>
                  </div>
                  <input
                    id="phone"
                    type="tel"
                    className="contact-input contact-phone-input"
                    placeholder=""
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <textarea
                name="message"
                className="contact-textarea"
                placeholder="Message"
                rows={3}
                value={form.message}
                onChange={handleChange}
              />
              <button type="submit" className="contact-submit-btn" disabled={loading}>
                {loading ? 'Sending...' : 'Submit'}
              </button>
            </form>
          )}
        </div>
        <div style={{ clear: 'both' }}></div>
      </div>
      <div className="contact-footer">
        <div className="contact-footer-links-box">
          <div className="contact-footer-inner">
            <p className="contact-text-center contact-text-black contact-mb-0">
              <Link className="contact-footer-link" href="/contact">
                <span className="contact-footer-link-text">contact us</span>
              </Link>
              <span className="contact-footer-link-text"> - </span>
              <Link className="contact-footer-link" href="/terms">
                <span className="contact-footer-link-text">Terms</span>
              </Link>
              <span className="contact-footer-link-text"> - </span>
              <Link className="contact-footer-link" href="/privacy">
                <span className="contact-footer-link-text">Privacy</span>
              </Link>
            </p>
          </div>
        </div>
        <div style={{ clear: 'both' }}></div>
        <div className="contact-footer-bg"></div>
      </div>
    </div>
  );
}
